//
// React hook to consume the loading registry.
//

import {
  useState,
  useEffect,
} from 'react';

import {
  getProgress,
  subscribe,
} from './loadingRegistry';

/**
 * Hook to get current loading progress and subscribe to updates.
 *
 * @returns {{
 *    total: number,
 *    done: number,
 *    progress: number,
 *    allComplete: boolean,
 *    loaders: Array }}
 */
function useLoadingProgress() {
  const [progress, setProgress] = useState(getProgress);

  useEffect(
    () => subscribe(setProgress),
    [],
  );

  return progress;
}

export default useLoadingProgress;
